import type { ChipProps } from '@column/column-ui-kit';

import { getTransferURL } from '~/lib/transfers/utils';
import { ACHTransferBatchRecord } from '~/typings/API';

export type RecordStatusMeta = { type: ChipProps['type']; label: string };

export const RECORD_STATUS_META: Record<string, RecordStatusMeta> = {
  pending: { type: 'default', label: 'Pending' },
  valid: { type: 'info', label: 'Valid' },
  invalid: { type: 'danger', label: 'Invalid' },
  succeeded: { type: 'success', label: 'Succeeded' },
  failed: { type: 'danger', label: 'Failed' },
};

export const transferUrlFor = (record: ACHTransferBatchRecord): string | undefined =>
  record.achTransferId
    ? getTransferURL(record.achTransferId, record.type === 'debit' ? 'ach_debit' : 'ach_credit')
    : undefined;
